import { api } from './client';
import type { SessionChain } from './sessions';

export interface GeoInfo {
  country: string;
  region: string;
  city: string;
}

export interface HourBucket {
  hour: string;
  successful: number;
  failed: number;
}

export interface FailingIp {
  ip: string;
  count: number;
  geo?: GeoInfo;
}

export interface UserLastLogin {
  username: string;
  last_login: string;
  ip: string;
  geo?: GeoInfo;
}

export interface LoginActivityData {
  logins_per_hour: HourBucket[];
  top_failing_ips: FailingIp[];
  last_login_per_user: UserLastLogin[];
  active_sessions: SessionChain[];
}

export interface UserLoginRecord {
  ts: string;
  result: 'success' | 'failure';
  ip: string;
  geo?: GeoInfo;
}

export interface UserLoginHistory {
  username: string;
  history: UserLoginRecord[];
}

export async function fetchLoginActivity(): Promise<LoginActivityData> {
  const { data } = await api.get<LoginActivityData>('/auth/activity');
  return data;
}

export async function fetchUserLoginHistory(username: string): Promise<UserLoginHistory> {
  const { data } = await api.get<UserLoginHistory>(`/auth/activity/user/${encodeURIComponent(username)}`);
  return data;
}
